var _defs, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcons02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fbf9f8;\n      }\n\n      .cls-2 {\n        fill: #152839;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 200,
    cy: 200,
    r: 196.43
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.25,325.29v-113.39h38.06l5.7-44.19h-43.76v-28.21c0-12.8,3.55-21.51,21.9-21.51h23.4v-39.54c-4.05-.53-17.94-1.74-34.1-1.74-33.73,0-56.83,20.59-56.83,58.41v32.59h-38.15v44.19h38.15v113.39h45.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcons02);
export default __webpack_public_path__ + "static/media/social_icons-02.7c33cb84f547a6eee583f0129d30df40.svg";
export { ForwardRef as ReactComponent };